import React from 'react';
import { MapPin } from 'lucide-react';

function BasicAddressCard({ address, addressField }) {
  if (!address) {
    return null;
  }

  return (
    <div
      id="AddressCard"
      className="mt-2 flex items-start gap-2"
      title={`listing field: ${addressField}`}
    >
      <MapPin size={16} className="mt-0.5 shrink-0 text-black" />
      <span className="text-sm text-black/80">{address}</span>
    </div>
  );
}

export default BasicAddressCard;
